module.exports = __webpack_public_path__ + "site/img/61.d598fb5f.jpg";